<script>
  import { fade } from "svelte/transition";
  import { reportCopy, getCopyId } from "../../stores/currentSelections.js";

  export let key;
  export let copy = getCopyId($reportCopy, `flag-${key}`);
  export let bgColor = "gray-200";
  export let textColor = "neutral-2";
  export let rounded = false;
</script>

<div
  class="w-full h-auto bg-{bgColor} text-{textColor} px-4 py-2 {rounded
    ? 'rounded-b-md'
    : ''}"
  transition:fade={{ duration: 300 }}
>
  <p class="tight">{copy}</p>
</div>
